import React from "react";

import styles from "./AllProducts.module.scss";

const AllProducts = ({ count }) => {
  return (
    <div className={styles.allProducts_outer_circle}>
      <div className={styles.allProducts_inner_circle}></div>
      <div className={styles.allProducts_circle}></div>
      <div className={styles.allProducts_count}>
        <b>{count}</b>
        <span>All Products</span>
      </div>
    </div>
  );
};

export default AllProducts;
